module.exports = __webpack_public_path__ + "img/zuopin1.868cab13.jpg";